import { filterData, sortDataLabel } from "./utils";

export const defaultOptions = [
    {value: 0, label: 'Львів'},
    {value: 1, label: 'Сокільники'},
    {value: 2, label: 'Дубляни'},
    {value: 3, label: 'Дрогобич'},
    {value: 4, label: 'Стрий'},
    {value: 5, label: 'Червоноград'},
    {value: 6, label: 'Радехів'},
    {value: 7, label: 'Рава-Руська'},
    {value: 8, label: 'Жовква'},
    {value: 9, label: 'Золочів'},
];

export const selectOptions = (getList, setList, id) => {
  getList(id).then((response)=>{
    const data = response['hydra:member'];
    const formatData = filterData(data).map(elements=>{
      // додаємо отг для населених пунктів
      return {value: elements.id, label: elements.otg !== undefined ? `${elements.name} (${elements.otg.name} ОТГ)` : elements.name}
    })

    return setList(sortDataLabel(formatData));
  }).catch((err)=>{
      console.log(err.message);
  });
}

// використовується тільки для населених пунктів для кращого пошуку
export const filterOption = ({ label, value }, string) => {
  const regex = /\([^)]*\)/g;
  const formatLabel = label.replace(regex, "").toLowerCase();

  if (formatLabel.includes(string.toLowerCase())){
    return true;
  }
  else {
    return false;
  }
};

export const chergTmp = [
  {
    "1.1": {
      "times": {
        "00:00": "1", "00:30": "1",
        "01:00": "10", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "0",
        "04:00": "0", "04:30": "0",
        "05:00": "0", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "10", "17:30": "1",
        "18:00": "10", "18:30": "1",
        "19:00": "10", "19:30": "1",
        "20:00": "10", "20:30": "1",
        "21:00": "10", "21:30": "1",
        "22:00": "10", "22:30": "0",
        "23:00": "10", "23:30": "1"
      }
    },
    "1.2": {
      "times": {
        "00:00": "1", "00:30": "10",
        "01:00": "1", "01:30": "10",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "0",
        "04:00": "0", "04:30": "0",
        "05:00": "0", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "0", "18:30": "0",
        "19:00": "0", "19:30": "0",
        "20:00": "0", "20:30": "0",
        "21:00": "0", "21:30": "0",
        "22:00": "0", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    },
    "2.1": {
      "times": {
        "00:00": "0", "00:30": "0",
        "01:00": "0", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "0",
        "04:00": "0", "04:30": "0",
        "05:00": "0", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "0", "18:30": "0",
        "19:00": "0", "19:30": "0",
        "20:00": "0", "20:30": "0",
        "21:00": "0", "21:30": "0",
        "22:00": "0", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    },
    "2.2": {
      "times": {
        "00:00": "0", "00:30": "0",
        "01:00": "0", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "0",
        "04:00": "0", "04:30": "0",
        "05:00": "0", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "0", "18:30": "0",
        "19:00": "0", "19:30": "0",
        "20:00": "0", "20:30": "0",
        "21:00": "0", "21:30": "0",
        "22:00": "0", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    },
    "3.1": {
      "times": {
        "00:00": "0", "00:30": "0",
        "01:00": "0", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "0",
        "04:00": "0", "04:30": "0",
        "05:00": "0", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "0", "18:30": "0",
        "19:00": "0", "19:30": "0",
        "20:00": "0", "20:30": "0",
        "21:00": "0", "21:30": "0",
        "22:00": "0", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    },
    "3.2": {
      "times": {
        "00:00": "0", "00:30": "0",
        "01:00": "0", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "0",
        "04:00": "0", "04:30": "0",
        "05:00": "0", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "0", "18:30": "0",
        "19:00": "0", "19:30": "0",
        "20:00": "0", "20:30": "0",
        "21:00": "0", "21:30": "0",
        "22:00": "0", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    },
    "4.1": {
      "times": {
        "00:00": "0", "00:30": "0",
        "01:00": "0", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "0",
        "04:00": "0", "04:30": "0",
        "05:00": "0", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "0", "18:30": "0",
        "19:00": "0", "19:30": "0",
        "20:00": "0", "20:30": "0",
        "21:00": "0", "21:30": "0",
        "22:00": "0", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    },
    "4.2": {
      "times": {
        "00:00": "0", "00:30": "0",
        "01:00": "0", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "0",
        "04:00": "0", "04:30": "0",
        "05:00": "0", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "0", "18:30": "0",
        "19:00": "0", "19:30": "0",
        "20:00": "0", "20:30": "0",
        "21:00": "0", "21:30": "0",
        "22:00": "0", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    },
    "5.1": {
      "times": {
        "00:00": "0", "00:30": "0",
        "01:00": "0", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "0",
        "04:00": "0", "04:30": "0",
        "05:00": "0", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "0", "18:30": "0",
        "19:00": "0", "19:30": "0",
        "20:00": "0", "20:30": "0",
        "21:00": "0", "21:30": "0",
        "22:00": "0", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    },
    "5.2": {
      "times": {
        "00:00": "0", "00:30": "0",
        "01:00": "0", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "10",
        "04:00": "1", "04:30": "1",
        "05:00": "10", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "10", "18:30": "1",
        "19:00": "1", "19:30": "1",
        "20:00": "1", "20:30": "10",
        "21:00": "0", "21:30": "0",
        "22:00": "0", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    },
    "6.1": {
      "times": {
        "00:00": "0", "00:30": "0",
        "01:00": "0", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "0",
        "04:00": "0", "04:30": "0",
        "05:00": "0", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "0", "18:30": "0",
        "19:00": "0", "19:30": "0",
        "20:00": "0", "20:30": "0",
        "21:00": "10", "21:30": "1",
        "22:00": "10", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    },
    "6.2": {
      "times": {
        "00:00": "0", "00:30": "0",
        "01:00": "0", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "10",
        "04:00": "1", "04:30": "1",
        "05:00": "10", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "0", "18:30": "0",
        "19:00": "0", "19:30": "0",
        "20:00": "0", "20:30": "0",
        "21:00": "0", "21:30": "0",
        "22:00": "0", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    },
    "Не входить": {
      "times": {
        "00:00": "0", "00:30": "0",
        "01:00": "0", "01:30": "0",
        "02:00": "0", "02:30": "0",
        "03:00": "0", "03:30": "10",
        "04:00": "1", "04:30": "1",
        "05:00": "10", "05:30": "0",
        "06:00": "0", "06:30": "0",
        "07:00": "0", "07:30": "0",
        "08:00": "0", "08:30": "0",
        "09:00": "0", "09:30": "0",
        "10:00": "0", "10:30": "10",
        "11:00": "1", "11:30": "1",
        "12:00": "1", "12:30": "1",
        "13:00": "1", "13:30": "1",
        "14:00": "10", "14:30": "0",
        "15:00": "0", "15:30": "0",
        "16:00": "0", "16:30": "0",
        "17:00": "0", "17:30": "0",
        "18:00": "0", "18:30": "0",
        "19:00": "0", "19:30": "0",
        "20:00": "0", "20:30": "0",
        "21:00": "0", "21:30": "0",
        "22:00": "0", "22:30": "0",
        "23:00": "0", "23:30": "0"
      }
    }
  }
]